import { Box } from '@chakra-ui/react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

type Point = { month: string; amount: string };

const MONTH_LABELS = [
  'ene', 'feb', 'mar', 'abr', 'may', 'jun',
  'jul', 'ago', 'sep', 'oct', 'nov', 'dic',
] as const;

function labelFor(monthKey: string): string {
  // monthKey is 'YYYY-MM'
  const [y, m] = monthKey.split('-');
  const idx = Number(m) - 1;
  return `${MONTH_LABELS[idx] ?? m} ${y!.slice(2)}`;
}

const fmtGTQ = new Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' });

export function MonthlyCollectionsChart({ data }: { data: Point[] }) {
  const chartData = data.map((p) => ({ label: labelFor(p.month), amount: Number(p.amount) }));
  return (
    <Box bg="bg.surface" borderWidth="1px" borderColor="border" rounded="lg" p={{ base: '4', md: '5' }} h="320px">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 8, right: 8, bottom: 0, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--chakra-colors-border)" vertical={false} />
          <XAxis dataKey="label" tickLine={false} axisLine={false} fontSize={12} />
          <YAxis hide />
          <Tooltip
            formatter={(value) => [fmtGTQ.format(Number(value ?? 0)), 'Ingresos']}
            cursor={{ fill: 'var(--chakra-colors-bg-subtle)' }}
            contentStyle={{
              background: 'var(--chakra-colors-bg-surface)',
              border: '1px solid var(--chakra-colors-border)',
              borderRadius: '6px',
              fontSize: '13px',
            }}
          />
          <Bar dataKey="amount" fill="var(--chakra-colors-brand-600)" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}
